/**
 * Account suspension banner (0038) — the ONLY client-facing surface of a
 * compliance hold. Copy is deliberately NEUTRAL: the cause (sanctions match,
 * fraud investigation…) is never disclosed (PLD no-tipping); no email is sent.
 * The account stays read-only: balances remain visible, every mutating action
 * returns 403 `account_suspended` server-side — this banner explains that
 * state so the client isn't left guessing at scattered errors.
 *
 * No dismiss button, no countdown, no urgency styling (per
 * client_engagement_position.md — informational, not alarmist).
 */
import { useCurrentUserProfile } from '../../hooks/useCurrentUserProfile';
import { colors } from '../../styles/theme';

export default function AccountSuspendedBanner(): JSX.Element | null {
  const profile = useCurrentUserProfile();
  if (profile?.suspension_status !== 'suspended') return null;

  return (
    <aside
      role="status"
      aria-live="polite"
      className="rounded-lg p-3 mb-4"
      style={{
        background: colors.warningBg,
        border: '1px solid #FCD34D',
      }}
    >
      <p className="text-sm font-semibold mb-1" style={{ color: colors.warning }}>
        Your account is under administrative review
      </p>
      <p className="text-xs" style={{ color: colors.ink }}>
        While the review is in progress you can view your balances and statements, but transactions and account changes are temporarily unavailable. Your money and your holdings are not affected. If you have questions, please contact support.
      </p>
    </aside>
  );
}
